<div class="item-grid-container">
    <h4 class="new-product-blk-title">Edit Product information</h4>
    <div class="new-product-form-container">
      <form (ngSubmit)="onProductDetails()" [formGroup]="updateProductForm">
        <div class="form-inner  content-details-blk">
          <div class="row my-2">
            <div class="col-12 col-xs-12 col-sm-6">
              <div class="row my-2">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <h4 class="form-item-label" translate>
                    pages.newRetailer.provider <span class="required">*</span>
                  </h4>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div class="form-item-input">
                    <mat-form-field appearance="outline">
                      <mat-select formControlName="providerName" disabled>
                        <mat-option
                          *ngFor="let provider of allProviders"
                          [value]="provider.providerId"
                        >
                          {{ provider.providerName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <h4 class="form-item-label" translate>
                    pages.newRetailer.productName <span class="required">*</span>
                  </h4>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div class="form-item-input">
                    <mat-form-field class="" appearance="outline">
                      <input
                        matInput
                        readonly
                        type="text"
                        placeholder="{{'pages.Addproducts.Enterproductname' | translate }}"
                        formControlName="productName"
                      />
                    </mat-form-field>
                    <div *ngIf="f.productName.touched && f.productName.invalid">
                      <div *ngIf="f.productName.errors.required">
                        <mat-hint class="text-danger ms-2">
                          {{'pages.placeholders.ProductNameIsRequired' | translate }}</mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
              <h4 class="form-item-label mt-3" translate>pages.newRetailer.productDescription</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <textarea
                    matInput
                    readonly
                    formControlName="productDescription"
                    placeholder="{{ 'pages.ManageProducts.ProductDescription' | translate}}"
                    class="text-area"
                  >
                  </textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
  
          <div class="row my-2">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>Product status</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select
                    formControlName="productStatus"
                    [(value)]="selectedstatus"
                    required
                    disabled
                  >
                    <mat-option value="Active">Active</mat-option>
                    <mat-option value="InActive">InActive</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
  
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.widelyUsed</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select
                    formControlName="widelyUsed"
                    [(value)]="selectedwidelyUsed"
                    required
                    disabled
                  >
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
  
          <div class="row my-2">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.productType</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select
                    formControlName="productType"
                    [(value)]="selectedproducttypes"
                    disabled
                  >
                    <mat-option
                      *ngFor="let productType of producttypes"
                      [value]="productType"
                    >
                      {{ productType }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.productService</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select
                    formControlName="productService"
                    [(value)]="selectedproductService"
                    disabled
                  >
                    <mat-option
                      *ngFor="let productService of providerService"
                      [value]="productService"
                    >
                      {{ productService }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
  
          <div class="row my-2">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.responseType</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select
                    formControlName="responseType"
                    [(value)]="selectedresponseTypes"
                    disabled
                  >
                    <mat-option
                      *ngFor="let responseType of responseTypes"
                      [value]="responseType"
                    >
                      {{ responseType }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="f.responseType.touched && f.responseType.invalid">
                  <div *ngIf="f.responseType.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{'pages.placeholders.ResponseTypeIsRequired' | translate }}</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.serviceCountry</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select
                    formControlName="serviceCountry"
                    [(value)]="selectedserviceCountry"
                    disabled
                  >
                    <mat-option
                      *ngFor="let country of serviceCountries"
                      [value]="country.countryName"
                    >
                      {{ country.countryName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
  
          <div class="row my-2">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>SKU</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    readonly
                    type="text"
                    [textMask]="{ mask: numMask, guide: false }"
                    formControlName="sku"
                    minlength="2"
                    maxlength="5"
                    disabled
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.transactionType</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select
                    formControlName="transactionType"
                    [(value)]="selectedtransactionTypes"
                    disabled
                  >
                    <mat-option
                      *ngFor="let transactionType of transactionTypes"
                      [value]="transactionType"
                    >
                      {{ transactionType }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
  
          <div class="row my-2">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.exchangeRate</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="" appearance="outline">
                  <input
                    matInput
                    type="text"
                    readonly
                    placeholder="Enter Exchange Rate"
                    formControlName="exchangeRate"
                    disabled
                  />
                </mat-form-field>
                <div *ngIf="f.exchangeRate.touched && f.exchangeRate.invalid">
                  <div *ngIf="f.exchangeRate.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{'pages.placeholders.ExchangeRateIsRequired' | translate }}</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.codeGroup</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select
                    formControlName="codeGroup"
                    [(value)]="selectedcodeGroups"
                    disabled
                  >
                    <mat-option *ngFor="let item of codeGroups" [value]="item">
                      {{ item }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
  
          <div class="row my-2">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>{{'pages.ManageProducts.Plantype' | translate }}</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select
                    formControlName="planType"
                    [(value)]="selectedplantypes"
                    disabled
                  >
                    <mat-option *ngFor="let item of plantypes" [value]="item">
                      {{ item }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.currency</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select
                    formControlName="currency"
                    [(value)]="selectedcurrency"
                    required
                    disabled
                  >
                    <mat-option value="USD">USD</mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="f.currency.touched && f.currency.invalid">
                  <div *ngIf="f.currency.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{'pages.placeholders.CurrencyIsRequired' | translate }}</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div class="row my-2">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.carrier</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select
                    formControlName="carrier"
                    [(value)]="selectedcarrier"
                    disabled
                  >
                    <mat-option
                      *ngFor="let carrierType of carrierTypes"
                      [value]="carrierType.carrierName"
                    >
                      {{ carrierType.carrierName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.purchaseDiscount</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="w-25" appearance="outline">
                  <mat-select
                    formControlName="purchaseDiscountType"
                    [(value)]="selectedpurchaseDiscountType"
                    disabled
                  >
                    <mat-option value="$">$</mat-option>
                    <mat-option value="%">%</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="w-75" appearance="outline">
                  <input
                    matInput
                    type="number"
                    readonly
                    placeholder="{{'pages.Addproducts.Enterpurchasediscount' | translate }}"
                    formControlName="purchaseDiscount"
                    disabled
                  />
                </mat-form-field>
                <div
                  *ngIf="f.purchaseDiscount.touched && f.purchaseDiscount.invalid"
                >
                  <div *ngIf="f.topupvalueCustomer.errors">
                    <mat-hint class="text-danger ms-2">
                      Purchase Discount is required.</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div class="row my-2">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.faceValueMin</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="" appearance="outline">
                  <input
                    matInput
                    type="text"
                    [textMask]="{ mask: numMask, guide: false }"
                    placeholder="{{'pages.Addproducts.Enterfacevalueminimum' | translate }}"
                    formControlName="faceValueMinAmt"
                    disabled
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.faceValueMax</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="" appearance="outline">
                  <input
                    matInput
                    type="text"
                    [textMask]="{ mask: numMask, guide: false }"
                    placeholder="{{'pages.Addproducts.Enterfacevaluemax' | translate }}"
                    formControlName="faceValueMaxAmt"
                    disabled
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
  
          <div formArrayName="commissionInfo">
            <ng-container>
              <div class="row">
                <div
                  class="col-lg-6 col-md-6 col-sm-6 col-xs-12"
                  *ngFor="let item of commissionInfo; let pointIndex = index"
                  [formGroupName]="pointIndex"
                >
                  <div class="row">
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                    >
                      <h4 class="form-item-label">
                        {{ item.priceListName }} ({{ item.priceListType }})
                        <!-- {{ item.key | json }} -->
                      </h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center"
                    >
                      <div class="form-item-input">
                        <mat-form-field appearance="outline">
                          <input
                            matInput
                            type="text"
                            placeholder="Enter {{ item.priceListName }}"
                            [formControlName]="item.priceListName"
                          />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
  
        <div class="form-footer">
          <ul class="list-inline text-center">
            <li class="list-inline-item">
              <button
                mat-raised-button
                color="primary"
                type="submit"
                class="rounded-0"
                [disabled]="checkSubmitDisplayed()"
              >
                <span translate class="translate">pages.newRetailer.update</span>
              </button>
            </li>
            <li class="list-inline-item">
              <button
                mat-stroked-button
                color="primary"
                type="button"
                class="rounded-0"
                (click)="onCancel()"
              >
                <span translate class="translate">pages.newRetailer.cancel</span>
              </button>
            </li>
            <li class="list-inline-item"></li>
          </ul>
        </div>
      </form>
    </div>
  </div>
  